import React, { useState, useEffect } from 'react';
import { Route, Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
// core components
import Header from "dashboard/general-management/components/Headers/Header.js";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {api} from '../../../../api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import Cookies from 'js-cookie';


const Client1 = () => {
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [showForm, setShowForm] = useState(false); // State to control form visibility
  const [showAddClientModal, setShowAddClientModal] = useState(false); // State to control "Add Client" modal visibility
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);        
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');


  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [deleteEmployee, setdeleteEmployee] = useState(null);



  const [clientForm, setClientForm] = useState([]);

  const [employeeIdToDelete, setEmployeeIdToDelete] = useState(null);

  const toggleDropdown = (id) => { 
    setDropdownOpen(prevState => ({
      ...prevState,
      [id]: !prevState[id]
    }));
  };

  const [clientData, setClientData] = useState([{ 
    // Initialize your form data fields here
    client_name: '',
    client_email: '',
    client_number: '',
    company_name: '',
    profile_image : null,
    address: ''  
  }]);  



  
  // Function to handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();  

    const formdata = new FormData();
    formdata.append("client_name",clientData.client_name);
    formdata.append("client_email",clientData.client_email);
    formdata.append("client_number",clientData.client_number);
    formdata.append("company_name",clientData.company_name);
    formdata.append("profile_image",clientData.profile_image);
    formdata.append("address",clientData.address);
    const company_id = Cookies.get('company_id');
    if (company_id) formdata.append("company_id", company_id);
    try {
      const response = await api.post(`clientGM.php?company_id=${company_id}`,formdata); 
      console.log("Data sent successfully:", response.data); 
      
      // Close the modal
      toggleAddClientModal();
      
      // Reset form data
      setClientData({
        client_name: '',
        client_email: '',
        client_number: '',
        company_name: '',
        profile_image: null,
        address: ''
      });
      setProfileImage(null);
      
      // Refresh the client list without page reload
      const refreshResponse = await api.get(`clientGM.php?company_id=${company_id}`);
      setTasks(Array.isArray(refreshResponse.data) ? refreshResponse.data : []);

      // Show success message
      setSuccessMessage('Client added successfully!');
      setShowSuccessAlert(true);
      // Auto-hide alert after 3 seconds
      setTimeout(() => {
        setShowSuccessAlert(false);
      }, 3000);

    } catch (error) {
      console.error("Error submitting data:", error);
      setSuccessMessage('Error adding client. Please try again.');
      setShowSuccessAlert(true);
      setTimeout(() => {
        setShowSuccessAlert(false);
      }, 3000);
    }

  }; 


  const toggleModal = () => setModalOpen(prevState => !prevState);

  const toggleAddClientModal = () => setShowAddClientModal(prevState => !prevState);

  // const toggleDeleteConfirmationModal = () => setShowDeleteConfirmationModal(prevState => !prevState);

  const handleAddClient = () => {
    // Show the form when "Add Client" is clicked  
    setShowForm(true);
    // Show the "Add Client" modal
    toggleAddClientModal();
  };

  <CKEditor
    editor={ClassicEditor}
    data={clientForm.description}
    onChange={(event, editor) => {
      const data = editor.getData(); 
      setClientForm(prevState => ({
        ...clientData,
        contract_details: data
      }));
    }}></CKEditor>



  const handleInputChange = (event) => {
    event.preventDefault(); 
    const {name, value}  = event.target
    // console.log(event.target);
    setClientData({
      ...clientData,
      [event.target.name]: event.target.value 
    }); 
    console.log(clientData); 
  }; 

  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`clientGM.php?company_id=${company_id}`);
        setTasks(Array.isArray(response.data) ? response.data : []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
        setTasks([]);
      }
    };
    fetchData();
  }, []);
  
 


  
  // Sample employee data (replace with your actual data)
  const employees = Array.isArray(tasks) ? tasks : [];

  console.log(tasks)
 
  // Function to filter employees based on search query
  const filterEmployees = () => {
    if (!searchQuery) {
      setFilteredEmployees(Array.isArray(employees) ? employees : []);
    } else {
      const filtered = (Array.isArray(employees) ? employees : []).filter(employee => 
        employee.client_name && employee.client_name.toLowerCase().includes(searchQuery.toLowerCase())
      ); 
      setFilteredEmployees(filtered); 
    }
  };
  

  // Update filtered employees when searchQuery changes
  useEffect(() => { 
    filterEmployees();
  }, [searchQuery], employees);
  

  
  const toggleViewMoreModal = (employee) => {
    setSelectedEmployee(employee);
  };

  const getImagePath = (imageName) => {
    if (!imageName) return '/images/default-profile.png';
    return `/images/${imageName}`;
  };



  const renderViewMoreModal = () => {
    if (!selectedEmployee) return null;
    
    return (
      <Modal isOpen={true} toggle={() => toggleViewMoreModal(null)}>
        <ModalHeader toggle={() => toggleViewMoreModal(null)}>Employee View</ModalHeader>
        <ModalBody style={{ justifyContent: 'center', textAlign: 'center' }}>
          <img
            alt="..."
            className="rounded-circle"
            src={getImagePath(selectedEmployee.profile_image)}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = getImagePath('default-profile.png');
            }}
            style={{
              width: 100,
              height: 100,
              borderRadius: '50%',
              objectFit: 'cover',
              display: 'block',
              margin: '0 auto 10px auto',
              boxShadow: '0 0 10px rgba(0,0,0,0.15)'
            }}
          />
          <p> <b>Name :</b>  {selectedEmployee.client_name}</p>
          <p><b>Email</b> : {selectedEmployee.client_email}</p>
          <p> <b>Mobile Number :</b>  {selectedEmployee.client_number}</p>
          <p><b>Company Name :</b> {selectedEmployee.company_name}</p>
        </ModalBody>
      </Modal> 
    );
  };


  const [deleteConfirmationEmployeeId, setDeleteConfirmationEmployeeId] = useState(null);

  
  const toggleDeleteConfirmationModal = (employeeId) => {
    setDeleteConfirmationEmployeeId(employeeId === deleteConfirmationEmployeeId ? null : employeeId);
  };

  const handleDropdownItemClick = (action, employeeId, employeeName) => {
    if (action === 'Delete') {
      // Open delete confirmation modal
      toggleDeleteConfirmationModal(employeeId);
    } else {
      console.log(`Clicked ${action}`);
    }
  };

  const handleDeleteConfirmation = (confirmed, employeeId) => {
    if (confirmed) {
      console.log(`Deleting employee with ID: ${employeeId}`);
      const fetchData = async () => {
        try {
          const company_id = Cookies.get('company_id');
          const response = await api.get(`deleteclient.php?id=${employeeId}&company_id=${company_id}`);
          console.log(response.data);
          
          // Refresh the client list without page reload
          const refreshResponse = await api.get(`clientGM.php?company_id=${company_id}`);
          setTasks(Array.isArray(refreshResponse.data) ? refreshResponse.data : []);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    }
    toggleDeleteConfirmationModal(employeeId);
  };

  const [profileImage, setProfileImage] = useState(null);

  
  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    // Check if a file is selected
    if (file) {
      console.log(file);
      setProfileImage(URL.createObjectURL(file));
      // Update the clientData state with the file
      setClientData(prevState => ({
        ...prevState,
        profile_image: file
      }));
    }
  };

  const displayClient = tasks.filter(client => 
    client.client_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const toggleSuccessAlert = () => setShowSuccessAlert(!showSuccessAlert);

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <Row className='mb-5'>
            <Col className="order-xl-2 mb-5 mb-xl-0 text-left ">
              <h1>Client Details</h1>
            </Col>
            <Col className="order-xl-2 mb-5 mb-xl-0 d-flex text-right">

              <Form className="navbar-search  form-inline ml-5 d-none d-md-flex ml-lg-auto ">
                <FormGroup className="mb-0 ml-6">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fas fa-search" style={{color: 'black'}}/>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Search Client Name"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}


                    />
                  </InputGroup>
                </FormGroup>
              </Form>
              <Col className="order-xl-2 mb-5 mb-xl-0 ">
                <Button onClick={handleAddClient} style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}>Add Client</Button>
              </Col>
            </Col>


          </Row>
        </Container>
        <Container fluid>
          <Row>
 
          {employees && employees.length >0 && employees.map(employee => (
        <Modal key={employee.client_id} isOpen={deleteConfirmationEmployeeId === employee.client_id} toggle={() => toggleDeleteConfirmationModal(employee.client_id)}>
          <ModalHeader toggle={() => toggleDeleteConfirmationModal(employee.client_id)}>Confirm Delete</ModalHeader>
          <ModalBody> 
            Are you sure you want to delete {employee.client_name}?
            <div className="mt-3 text-right">
              <form  > 
              <Button color="danger" onClick={() => handleDeleteConfirmation(true, employee.client_id)}>{`Yes, delete ${employee.client_name}`}</Button>{' '}
              </form>
              <Button color="secondary" onClick={() => handleDeleteConfirmation(false, employee.client_id)}>No</Button>
            </div>     
          </ModalBody>
        </Modal>
      ))}

            {displayClient.map(employee => (
              <Col md="3" key={employee.client_id}>
                  <Card className="card-profile shadow mb-5" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff',borderRadius: '15px'}}>
                  <Row className="justify-content-center">
                    <Col className="order-lg-2" lg="3">
                      <div className="card-profile-image">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img
                            alt="..."
                            className="rounded-circle"
                            src={getImagePath(employee.profile_image)}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = getImagePath('default-profile.png');
                            }}
                            style={{ height: 100, width: 100, objectFit: 'cover' }}
                          />
                        </a> 
                      </div>  
                      {/* Three-dot icon */}

                      <Dropdown isOpen={dropdownOpen[employee.client_id]} toggle={() => toggleDropdown(employee.client_id)} style={{ top: '5px', left: '110px' }}>
                        <DropdownToggle
                          tag="span"
                          data-toggle="dropdown"
                          aria-expanded={dropdownOpen}
                          caret
                          style={{ cursor: "pointer", justifyContent: 'center', }}
                        >
                          <i className="fas fa-ellipsis-v"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                          <Link to={`/general-admin/general-management/editclient1/${employee.client_id}`} style={{ color: 'Black' }}><DropdownItem onClick={() => console.log('Edit clicked')}>Edit</DropdownItem></Link>
                          <DropdownItem onClick={() => handleDropdownItemClick("Delete", employee.client_id, employee.client_name)}>Delete</DropdownItem>
                           
                        </DropdownMenu>  
                      </Dropdown>  
                    </Col>  
                  </Row>

                  <CardBody className="pt-0 pt-md-5 mt-5">
                    <div className="text-center">
                      <h3>
                        {employee.client_name}
                        <span className="font-weight-light">, {}</span>
                      </h3>
                      <div className="h4 font-weight-300">
                        {employee.client_email}
                      </div>
                      <div className="h5 font-weight-300">
                        {employee.client_number}
                      </div>

                      <hr className="my-4" /> 
                      <a href="#pablo" onClick={() => toggleViewMoreModal(employee)}> 
                        View more
                      </a>
                      
                    </div>

                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row> 
        </Container>
      </div>

      {/* Add Client Modal */}  
      <Modal isOpen={showAddClientModal} toggle={toggleAddClientModal}> 
        <ModalHeader toggle={toggleAddClientModal}>Add Client</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
          <Row className="justify-content-center align-items-center">
                      <Col lg="12" className="text-center mb-3">
                        {!profileImage && (
                          <div
                            className="profile-image-container"
                            style={{
                              width: '120px',
                              height: '120px',
                              border: '2px solid black',
                              borderRadius: '50%',
                              overflow: 'hidden',
                              boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
                              margin: '0 auto',
                            }}
                          >
                            {tasks.profile_image && (
                              <img
                                src={getImagePath(tasks.profile_image)}
                                alt="Placeholder"
                                name="image"
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = getImagePath('default-profile.png');
                                }}
                              />
                            )}
                          </div>
                        )}
                        {profileImage && (
                          <div
                            className="profile-image-container"
                            style={{
                              width: '120px',
                              height: '120px',
                              border: '2px solid black',
                              borderRadius: '50%',
                              overflow: 'hidden',
                              boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
                              margin: '0 auto',
                            }}
                          >
                            <img
                              src={profileImage}
                              alt="Profile"
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                              }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = getImagePath('default-profile.png');
                              }}
                            />
                          </div>
                        )}
                      </Col>

                      <Col lg="12" className="text-center">
                        <Tippy content="Upload Profile Image" placement="top">
                          <span>
                            <Button
                              style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                              onClick={() => document.getElementById('input-profile-image').click()}
                            >
                              <FontAwesomeIcon icon={faPencilAlt} /> Profile Image   
                            </Button>
                          </span>
                        </Tippy>

                        <FormGroup style={{ display: 'none' }}>
                          <Input
                            type="file"
                            id="input-profile-image"
                            accept="image/*"
                            onChange={handleFileUpload}
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
            <Row form >
            <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-name">Client Name</label><span style={{ color: 'red' }}>*</span>
                  <Input
                    className="form-control-alternative"
                    id="input-name"
                    type="text"
                    name="client_name"
                    onChange={handleInputChange} 
                    placeholder='Client Name'
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-name">Client Email</label><span style={{ color: 'red' }}>*</span>
                  <Input
                    className="form-control-alternative"
                    id="input-name"
                    type="email"
                    name="client_email"
                    onChange={handleInputChange}
                    required
                    placeholder='Client Email'
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-name">Client Number</label><span style={{ color: 'red' }}>*</span>
                  <Input
                    className="form-control-alternative"
                    id="input-name"
                    type="number"
                    name="client_number"
                    onChange={handleInputChange}
                    required
                    placeholder='Client Number'
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-name">Company Name</label><span style={{ color: 'red' }}>*</span>
                  <Input
                    className="form-control-alternative"
                    id="input-name"
                    type="text"
                    name="company_name"
                    onChange={handleInputChange}
                    required
                    placeholder='Company Name'
                  />
                </FormGroup>
              </Col>
              {/* <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-name">Project Name</label>
                  <Input
                    className="form-control-alternative"
                    id="input-name"
                    type="text"
                    name="p_name"
                    onChange={handleInputChange}
                    required
                    placeholder='Project Name' 
                  />  
                </FormGroup>
              </Col>
              <Col md={6}>
                                <FormGroup>
                                <label className="form-control-label" htmlFor="input-location">Project Timeline</label>
                                <Input
                                    className="form-control-alternative"
                                    id="input-location"
                                    type="datetime-local"
                                    name="p_timeline"
                                    onChange={handleInputChange} 
                                />
                                </FormGroup>
                            </Col> */}
             
            </Row>
            {/* <Row form>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-location">Project SquareFeet</label>
                  <Input
                    className="form-control-alternative"
                    id="input-location"
                    type="text"
                    name="p_sqrfeet"
                    required
                    placeholder='Enter Squarefeet'
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-position">Project Budget</label>
                  <Input
                    className="form-control-alternative"
                    id="input-position"
                    type="number"
                    name="p_budget"
                    onChange={handleInputChange}
                    required
                    placeholder='Project Budget'
                  />
                </FormGroup>
              </Col>
            </Row> */}
           
            <Row form>
            
              <Col md={12}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-location">Location</label><span style={{ color: 'red' }}>*</span>
                  <Input
                    className="form-control-alternative"
                    id="input-name"
                    type="location"
                    name="address"
                    required
                    onChange={handleInputChange}
                    placeholder='Location'
                  />
                </FormGroup>
              </Col>
              {/* <Col md={12}>
              <FormGroup>
              <label htmlFor="contract_details">Contract Details</label>
              <CKEditor
                editor={ClassicEditor}
                data={clientData.contract_details}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setClientData(prevState => ({
                    ...prevState,
                    contract_details: data
                  }));
                }}  
                required
              />
            </FormGroup>
              </Col> */}
            </Row>
            <Button type="submit"  style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }}  >Submit</Button>
          </Form>
        </ModalBody>
      </Modal>
 
      {renderViewMoreModal()} 
                  

      {/* Custom Centered Success Alert */}
      {showSuccessAlert && (
          <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
              paddingTop: '15%',
              zIndex: 9999
          }}>
              <div style={{
                  backgroundColor: 'white',
                  padding: '30px',
                  borderRadius: '15px',
                  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
                  textAlign: 'center',
                  maxWidth: '400px',
                  width: '90%',
                  border: '3px solid #d86f89'
              }}>
                  <div style={{
                      fontSize: '48px',
                      color: '#d86f89',
                      marginBottom: '20px'
                  }}>
                      {successMessage.includes('successfully') ? '✓' : '✗'}
                  </div>
                  <h4 style={{
                      color: successMessage.includes('successfully') ? '#28a745' : '#dc3545',
                      marginBottom: '15px'
                  }}>
                      {successMessage.includes('successfully') ? 'Success!' : 'Error!'}
                  </h4>
                  <p style={{
                      color: '#333',
                      fontSize: '16px',
                      marginBottom: '20px'
                  }}>
                      {successMessage}
                  </p>
                  <Button 
                      style={{ 
                          backgroundColor: '#d86f89', 
                          borderColor: '#d86f89', 
                          color: 'white',
                          padding: '10px 25px',
                          borderRadius: '25px'
                      }}
                      onClick={toggleSuccessAlert}
                  >
                      OK
                  </Button>
              </div>
          </div>
      )}
      
    </>
  
  );
};

export default Client1;
